<a class="link" (click)="redirectToHref(href)" [ngClass]="['link--' + color, isShrink ? 'link--shrink' : '']" [routerLink]="link ? link : null" [href]="href" [routerLinkActive]="'active'" [target]="target" [routerLinkActiveOptions]="{ exact: exactMatch }" [matTooltip]="tooltip" matTooltipPosition="after">
    <div class="icon-wrapper">
        <span class="icon" [ngClass]="iconClass"></span>
    </div>
    <div class="name" #contentWrapper>
        <ng-content></ng-content>
    </div>
</a>
